import { render, staticRenderFns } from "./ChangeBusinessIcon.vue?vue&type=template&id=2cb96d70&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb96d70')) {
      api.createRecord('2cb96d70', component.options)
    } else {
      api.reload('2cb96d70', component.options)
    }
    module.hot.accept("./ChangeBusinessIcon.vue?vue&type=template&id=2cb96d70&", function () {
      api.rerender('2cb96d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/ChangeBusinessIcon.vue"
export default component.exports